
















import Vue from "vue";
import Component from "vue-class-component";
import AtendenteService from "@/services/AtendenteService";
import { Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class DialogDeleteAtendentes extends Vue {
  @Prop({ required: true }) dialog!: boolean;
  @Prop() pessoaId!: number;
  @Watch("dialog")
  dialogRootChange() {
    this.$emit("update:dialog", this.dialog);
  }
  async deletePessoa() {
    await AtendenteService.delete(this.pessoaId);
    this.dialog = false;
  }
}
